module.exports = __webpack_public_path__ + "img/wechat.78db8a26.jpg";